import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { Pane } from '@sheridan-prize/ui';
import { UserProfilePreview } from '../components/UserProfilePreview';
import { Divider } from '@moonjellydigital/react-components';

export const Route = createFileRoute('/profiles_/$userId')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();
    const userRole = getAuthStore().getUser()?.role;

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (userRole !== 'superadmin' && userRole !== 'admin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useParams();

  return (
    <>
      <SpSidebar />
      <Pane tag="main" classes={'sp-main'}>
        <h1>Viewing Profile</h1>
        <Divider semantic={false} orientation="horizontal" />
        <UserProfilePreview userId={userId} />
      </Pane>
    </>
  );
}
